import React, {useEffect, useState} from 'react';
import {
   ImageBackground,
   View,
   StyleSheet,
   Image,
   Text,
   TouchableOpacity,
   Dimensions,
   Platform,
} from 'react-native';
//import {AnimatedCircularProgress} from 'react-native-circular-progress';
import UICircularProgress from '../../components/circular-progress';
import {
   selectScreenOrientation,
   selectLandscapeSmallWebView,
} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
import {
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_MEDIUM,
   WHITE_ICON_HOVER_TINT_COLOR,
} from '../../utils/utils';
import FinalTestReview from './FinalTestReview';

export const StartFinalTest = props => {
   const isPreTeastEnable = props.isPreTeastEnable;
   const isFinalTestReviewEnable = props.isFinalTestReviewEnable;
   const percentage = isPreTeastEnable ? 100 : props.requiredPercentage;
   const title = isPreTeastEnable ? 'Pre Test' : 'Final Test';
   const subTitle = isPreTeastEnable
      ? 'You are about to start the pre-test test.'
      : 'You are about to start the final test.';
   const mMessage = `A Score of ${percentage}% is required to pass.`;
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const Dimenesion = Dimensions.get('window');
   const width = Math.max(Dimenesion.width, Dimenesion.height);
   const height = Math.min(Dimenesion.width, Dimenesion.height);
   const isWeb = Platform.OS === 'web';
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const [isHoverBegenTest, setHoverBegenTest] = useState(false);
   if (isFinalTestReviewEnable) {
      return (
         <FinalTestReview
            proceed={() => {
               props.proceed();
            }}
         />
      );
   }
   return (
      <View
         style={[
            {
               flex: 1,
               backgroundColor: '#000000',
               justifyContent: 'center',
               ...Platform.select({
                  web: {
                     flex: null,
                     height: '100%',
                  },
               }),
            },
            isWeb &&
               !isLandscapeMode &&
               !isLandscapeSmallWebView && {
                  ...Platform.select({
                     web: {
                        height: '100vw',
                        top: '100vh',
                        left: 0,
                        transform: 'rotate(-90deg)',
                        transformOrigin: 'left top',
                        width: '100vh',
                     },
                  }),
               },
         ]}>
         <ImageBackground
            source={require('../../assets/bg_final_test_new.png')}
            style={[
               styles.backgroundImage,
               {
                  ...Platform.select({
                     web: {
                        height: '100%',
                     },
                  }),
               },
            ]}>
            <View
               style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  resizeMode: 'contain',
                  alignItems: 'center',
                  opacity: 0.5,
               }}
            />
            <View
               style={{
                  marginTop: isLandscapeMode ? height * 0.16 : height * 0.06,
                  marginBottom: isLandscapeMode ? height * 0.16 : height * 0.06,
                  alignItems: 'center',
                  ...Platform.select({
                     web: {
                        marginBottom: 0,
                        marginTop: 0,
                        justifyContent: 'center',
                        height: '100%',
                        paddingVertical: '5%',
                     },
                     android: {
                        flex: 1,
                        justifyContent: 'center',
                        marginTop: isLandscapeMode ? null : height * 0.06,
                        marginBottom: isLandscapeMode ? null : height * 0.06,
                     },
                  }),
               }}>
               <View
                  style={{
                     flexDirection: isLandscapeMode ? 'column' : 'row',
                     alignItems: 'center',
                  }}>
                  <Image
                     source={require('../../assets/quiz_final_test.png')}
                     style={{
                        width: isLandscapeMode ? 104 : 40,
                        height: isLandscapeMode ? 104 : 40,
                        alignItems: 'center',
                     }}
                  />
                  <Text
                     style={{
                        marginTop: 5,
                        color: '#26E555',
                        fontSize: isLandscapeMode ? 32 : 28,
                        fontFamily: FONT_FAMILY_REGULAR,
                        marginLeft: isLandscapeMode ? 0 : 8,
                        alignSelf: 'center',
                        justifyContent: 'center',
                        fontWeight: '700',
                     }}>
                     {title}
                  </Text>
               </View>
               <Text
                  style={{
                     color: '#FFFFFF',
                     fontFamily: FONT_FAMILY_REGULAR,
                     fontWeight: isLandscapeMode ? '400' : '600',
                     //opacity: Platform.OS === 'web' ? 1 : 0.6,
                     fontSize: isLandscapeMode ? 24 : 20,
                     marginTop: isLandscapeMode ? 24 : 10,
                  }}>
                  {subTitle}
               </Text>
               <View
                  style={{
                     paddingHorizontal: 20,
                     flexDirection: 'row',
                     alignItems: 'center',
                     justifyContent: 'center',
                     marginTop: isLandscapeMode ? 40 : 24,
                     borderRadius: 16,
                     height: isLandscapeMode ? height * 0.16 : height * 0.3,
                     width: isLandscapeMode ? width * 0.6 : width * 0.9,
                     ...Platform.select({
                        web: {
                           height: '24%',
                           paddingVertical: isLandscapeMode ? 66 : 16,
                        },
                     }),
                  }}>
                  <View
                     style={{
                        position: 'absolute',
                        height: isLandscapeMode ? height * 0.16 : height * 0.3,
                        width: isLandscapeMode ? width * 0.7 : width * 0.7,
                        backgroundColor: '#FFFFFF',
                        opacity: 0.2,
                        borderRadius: 16,
                        ...Platform.select({
                           web: {
                              height: '100%',
                              width: isLandscapeMode
                                 ? width * 0.6
                                 : isLandscapeSmallWebView
                                 ? width * 0.9
                                 : '80vh',
                              paddingVertical: !isLandscapeMode ? 48 : null,
                           },
                        }),
                     }}
                  />
                  <View>
                     <UICircularProgress
                        size={isLandscapeMode ? 96 : 80}
                        width={isLandscapeMode ? 10 : 7}
                        fill={parseInt(percentage, 10)}
                        rotation={180}
                        tintColor="#26E555"
                        backgroundColor={
                           Platform.OS !== 'web' ? '#2d3137' : '#001231'
                        }
                        onlyPercentage={true}
                        percentFont={24}
                        trailStroke={'#808080'}
                        bgOpacity={Platform.OS !== 'web' ? 1 : 0.2}
                     />
                  </View>
                  <Text
                     style={{
                        color: '#FFFFFF',
                        fontFamily: FONT_FAMILY_REGULAR,
                        fontWeight: '400',
                        fontSize: 24,
                        marginLeft: isLandscapeMode ? 24 : 16,
                     }}>
                     {mMessage}
                  </Text>
               </View>
               <Text
                  style={{
                     color: '#FFFFFF',
                     fontFamily: FONT_FAMILY_REGULAR,
                     fontWeight: isLandscapeMode ? '400' : '600',
                     //opacity: Platform.OS === 'web' ? 1 : 0.6,
                     fontSize: isLandscapeMode ? 24 : 20,
                     marginTop: isLandscapeMode ? 64 : 24,
                  }}>
                  Click below button to begin test.
               </Text>
               <TouchableOpacity
                  onMouseEnter={() => setHoverBegenTest(true)}
                  onMouseLeave={() => setHoverBegenTest(false)}
                  onPress={() => {
                     props.proceed();
                  }}>
                  <View
                     style={{
                        flexDirection: 'row',
                        width: isLandscapeMode ? 179 : width * 0.156,
                        height:
                           Platform.OS === 'windows'
                              ? null
                              : isLandscapeMode
                              ? 72
                              : height * 0.106,
                        backgroundColor: isHoverBegenTest
                           ? WHITE_ICON_HOVER_TINT_COLOR
                           : '#F2F5FF',
                        marginTop: isLandscapeMode ? 24 : 16,
                        paddingHorizontal: isLandscapeMode ? 20 : 15,
                        paddingVertical: isLandscapeMode ? 16 : 16,
                        borderRadius: 6,
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...Platform.select({
                           web: {
                              width: null,
                              height: null,
                              marginTop: isLandscapeMode ? 47 : 16,
                              paddingHorizontal: isLandscapeMode ? 24 : 15,
                              paddingVertical: isLandscapeMode ? 20 : 10,
                           },
                        }),
                     }}>
                     <Image
                        style={{
                           width: isLandscapeMode ? 24 : 18,
                           height: isLandscapeMode ? 24 : 18,
                        }}
                        source={require('../../assets/correct_begin_test.png')}
                     />
                     <Text
                        style={{
                           color: '#003DA5',
                           fontFamily: FONT_FAMILY_MEDIUM,
                           fontWeight: isLandscapeMode ? '500' : '700',
                           fontSize: isLandscapeMode ? 20 : 14,
                           marginLeft: 10,
                           height: !isLandscapeMode ? 18 : null,
                        }}>
                        Begin Test
                     </Text>
                  </View>
               </TouchableOpacity>
            </View>
         </ImageBackground>
      </View>
   );
};

const styles = StyleSheet.create({
   backgroundImage: {
      flex: 1,
      resizeMode: 'contain', // or 'stretch'
      alignItems: 'center',
   },
});

export default StartFinalTest;
